<ng-container *ngIf="restNoRoute && !disconnected && !pageLoading">
  <h3 class="mb10">Trouble connecting your website</h3>
  <p class="mb17">Connection issues can occur for the following reasons. Fix them to proceed.</p>

  <div class="db-booster-trouble-instructions-list">
    <p><a (click)="!!isIO || ioIsActive || (imageOptimizerPlugin && !imageOptimizerPlugin?.active) ? downloadIOPlugin() : downloadBoosterPlugin()">{{!!isIO || ioIsActive || (imageOptimizerPlugin && !imageOptimizerPlugin?.active) ? 'Image Optimizer' : '10Web Booster'}} plugin</a>&nbsp; is not installed and/or connected</p>
    <p class="mt10">Rest API is blocked</p>
    <p class="mt10">Website is not available or has an invalid SSL certificate</p>
    <p class="mt10">Security plugin or firewall is blocking 10Web service IPs</p>
  </div>

  <div class="db-booster-trouble-instructions__footer mt30">
    <button class="ds-btn-blue" (click)="closeModal()" *ngIf="!insideWebsite">
      <span>Got It</span>
    </button>
    <p *ngIf="insideWebsite && currentSubscription?.plan.cdnService"><a (click)="redirect()">You can still manage Cloudflare settings</a></p>
  </div>
</ng-container>

<ng-container *ngIf="!restNoRoute && (disconnected || !website.isActive) && !pageLoading">
  <h3 class="mb10">Trouble connecting your website</h3>
  <p class="mb25">To continue using {{!!isIO || ioIsActive || (imageOptimizerPlugin && !imageOptimizerPlugin?.active) ? 'Image Optimizer' : '10Web Booster'}}, please reconnect your site.<br/> You will need to download, install, and connect {{!!isIO || (imageOptimizerPlugin && !imageOptimizerPlugin?.active) ? 'Image Optimizer' : '10Web Booster'}} plugin.</p>

  <div class="mb30 db-booster-trouble-instructions">
    <p><b>Download {{!!isIO || ioIsActive || (imageOptimizerPlugin && !imageOptimizerPlugin?.active) ? 'Image Optimizer' : '10Web Booster'}}</b><i class="db-icon db-icon-ds-manage" [ngClass]="{'green': insideWebsite}"></i><b>Install and activate</b><i class="db-icon db-icon-ds-manage" [ngClass]="{'green': insideWebsite}"></i><b>Connect</b></p>
  </div>

  <div class="db-booster-trouble-instructions__footer">
    <p>Also available on<br/> WordPress.org</p>
    <button class="ds-btn-{{insideWebsite ? 'green' : 'blue'}}"  (click)="!!isIO || ioIsActive || (imageOptimizerPlugin && !imageOptimizerPlugin?.active) ? downloadIOPlugin(): downloadBoosterPlugin()">
      <span *ngIf="!loading">Download</span>
      <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
    </button>
  </div>
</ng-container>

<db-loading-screen [pageBlocker]="true" [ngClass]="{'hidden': !pageLoading}"></db-loading-screen>
